import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import  Sidebar from "./Sidebar";
import Fade from 'react-reveal/Fade';




class TERANGAplus extends Component {
  render() {
    return (
    <div>
    <section className="inner-intro bg-image overlay-dark parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg3.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Nos Produits</h2>
                    <div className="page-breadcrumb">
                        <a>Nos Produits</a>/<img src="/assets/img/logos/terangaplus.png" className="page_ter_plus"/>
                    </div>
                </div>
            </div>
        </section>     
   <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info Teranga-Page">
                <div className="row text-center inside_content">

                  <div className="col-md-12">
                  <div className="">
                   
                    <h2 className="terplus"> <b className="keywords"><img src="/assets/img/logos/terangaplus.png" className="terangaplus_img titlePlus"/></b></h2>

                    <div className="row">
                      <div className="col-md-12">

                    <p><b className="keywords"><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/></b>  est un engrais organique riche en éléments nutritifs Majeurs (N-P-K),  en éléments secondaires (Ca - Mg- Na) et en Oligo-éléments d’origine organique. </p>
                    <p><b className="keywords"><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/></b>  constitue un engrais organique de croissance par excellence. </p>
                    <div className="row sol">
                          <div className="col-md-5">
     
                          <Fade right>
                          <img src="/assets/img/images/branding/pmg7.jpg" className="images_sol"/>
                            </Fade>
                        </div>
                         <div className="col-md-7">
                         
                          <p><b>Effets du <b className="keywords"><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/></b> sur le sol :</b></p>
                         <Fade left>
                          <p><i className="fa fa-check-circle"></i>Corriger les déficiences du sol en un ou plusieurs éléments.</p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">Renforcer les possibilités de nutrition du sol, lorsque ses réserves mobilisables, les restitutions organiques et les synthèses microbiennes sont insuffisantes.</span></p>
                          <p><i className="fa fa-check-circle"></i>Stimuler l’activité microbienne,</p>
                          <p><i className="fa fa-check-circle"></i>Libérer des éléments fertilisants du sol,</p>
                          <p><i className="fa fa-check-circle"></i>Préserver la fertilité naturelle et diminuer les risques de lessivage.</p>

                         </Fade>
                          </div>
                         
                    </div>
                    <div className="row sol">
                          
                         <div className="col-md-7">
                         <Fade left>
                         <p className=" titre_teranga"><b>Effets du <b className="keywords"><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/></b>  sur la plante :</b></p>
                             <p className=" titre_teranga">Le <img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/> a une action indirecte sur le développement des plantes en créant toutes les conditions propices à leur plein épanouissement en :</p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">Assurant une nutrition régulière et équilibrée des végétaux tout au long de leur cycle sans aucun risque de carences pour les plantes.</span></p>
                          <p><i className="fa fa-check-circle"></i>Stimulant l’implantation au moment de la levée.</p>
                          <p><i className="fa fa-check-circle"></i>Augmentant l’enracinement,</p>
                          <p><i className="fa fa-check-circle"></i>Renforçant les défenses naturelles,</p>
                          <p><i className="fa fa-check-circle"></i>Limitant la pression fongique.</p>
                          <p><i className="fa fa-check-circle"></i>Assurant une nutrition équilibrée, complète et progressive.</p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">L’apport de <img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/> permet d’augmenter de façon significative l’activité biologique d’un sol, de favoriser les échanges sol/plante et de réduire les phénomènes de parasitisme.</span></p>

                         </Fade>
                         </div>
                         <div className="col-md-5">
     
                          <Fade right>
                          <img src="/assets/img/images/branding/pmg3.jpg" className="images_sol"/>
                            </Fade>
                       
                          </div>
                         
                    </div>
                    <div className="row sol">
                    <div className="col-md-5">
      
                          <Fade right>
                          <img src="/assets/img/images/branding/pmg5.jpg" className="images_sol"/>
                            </Fade>
                      
                          </div>
                          <div className="col-md-7">
                          <Fade left>
                          <p><b>Effets du <b className="keywords"><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/></b> sur l’environnement :</b></p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation"><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/> bénéficie d’un contrôle strict des matières premières servant à sa fabrication et en particulier des métaux lourds.</span></p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">Le mode d’action des éléments contenus dans le <img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/>  permet de réduire les pertes par lessivage et les pertes par volatilisation dans l’air. Il augmente la capacité des plantes à capter le CO2 présent dans l’air.</span></p>
                          <p><i className="fa fa-check-circle"></i><span className="alignation">L’apport de <img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/> permet d’augmenter de façon significative l’activité biologique d’un sol, de favoriser les échanges sol/plante et de réduire les phénomènes de parasitisme.</span></p>
                          <p><img src="/assets/img/logos/terangaplus.png" className="terang_inner_page"/> est utilisé en Agriculture Biologie et en conventionnelle avec :</p>
                          <p><i className="fa fa-check-circle"></i>Taux de matières organiques origine végétale élevé, donc humifiable. </p>
                          <p><i className="fa fa-check-circle"></i>Absence de pathogènes de graines et de mauvaises herbes.</p>
                          <p><i className="fa fa-check-circle"></i>Application mécanique facilitée par sa forme granulée.</p>
                          <p><i className="fa fa-check-circle"></i>Valorisation et rentabilité de la dépense minérale.</p>
 
                          </Fade>
                          </div>
                          
                          
                     </div>

                      </div>
                     
                      </div>
                      

                     
              
            
            </div>
             </div>
              </div>
               </div>
        </section>
<hr />

    </div>
       
        

    )
  }
}
export default TERANGAplus;


// WEBPACK FOOTER //
// ./src/components/terangaPlus.jsx